<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="300px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja nakładu produktu
                </h1>
            </v-card-title>

            <v-card-text>
                <v-row dense class="my-0">
                    <v-col cols="4" class="text-right font-weight-bold mt-2">
                        Nakład:
                    </v-col>
                    <v-col cols="8">
                        <v-text-field
                            v-model.number="orderProduct.amount"
                            min="1"
                            :error-messages="valueErrors"
                            dense
                            required
                            outlined
                            reverse
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row dense class="my-0">
                    <v-col cols="4" class="text-right font-weight-bold mt-2">
                        Naddatek:
                    </v-col>
                    <v-col cols="8">
                        <v-text-field
                            v-model="orderProduct.extraAmount"
                            dense
                            outlined
                            reverse
                            hide-details
                            disabled
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators'

export default {
    name: 'ProductAmountDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        orderProductData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            orderProduct: {
                amount: 0,
                extraAmount: 0
            },
        }
    },
    validations: {
        orderProduct: {
            amount: {
                required,
                integer
            }
        }
    },
    computed: {
        // Walidacje
        valueErrors() {
            const errors = []

            if (!this.$v.orderProduct.amount.$dirty) return errors
            !this.$v.orderProduct.amount.required && errors.push('Proszę podać nakład.')
            !this.$v.orderProduct.amount.integer && errors.push('Proszę podać liczbę naturalną.')

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.orderProduct = JSON.parse(JSON.stringify(this.orderProductData))
            }
        },
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            this.$emit('on-save', this.orderProduct)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.orderProduct = {
                    amount: 0,
                    extraAmount: 0
                }
                this.$v.$reset()
            }, 500)

            this.$emit('on-close')
        }
    }
}
</script>